import { render, staticRenderFns } from "./payment-history.vue?vue&type=template&id=384fb4e4&scoped=true"
import script from "./payment-history.vue?vue&type=script&lang=js"
export * from "./payment-history.vue?vue&type=script&lang=js"
import style0 from "./payment-history.vue?vue&type=style&index=0&id=384fb4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384fb4e4",
  null
  
)

export default component.exports